import { TypeTransaction } from "./TypeTransaction";

export class Transaction{

  constructor(
  public id?:number,
  public user_id?:number,
  public customer_id?: number,
  public type_transaction_id?: number,
  public pair_id?: number,
  public point_of_sell_id?: number,
  public quantity?: string
  ){}
}
